module.exports = __webpack_public_path__ + "img/212w.87f5185.jpg";